'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var i18nUtil_common = createCommonjsModule(function (module) {
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "5a0c":
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ module.exports=n();}(this,function(){var t="millisecond",n="second",e="minute",r="hour",i="day",s="week",u="month",o="quarter",a="year",h=/^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/,f=/\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,c=function(t,n,e){var r=String(t);return !r||r.length>=n?t:""+Array(n+1-r.length).join(e)+t},d={s:c,z:function(t){var n=-t.utcOffset(),e=Math.abs(n),r=Math.floor(e/60),i=e%60;return (n<=0?"+":"-")+c(r,2,"0")+":"+c(i,2,"0")},m:function(t,n){var e=12*(n.year()-t.year())+(n.month()-t.month()),r=t.clone().add(e,u),i=n-r<0,s=t.clone().add(e+(i?-1:1),u);return Number(-(e+(n-r)/(i?r-s:s-r))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return {M:u,y:a,w:s,d:i,h:r,m:e,s:n,ms:t,Q:o}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},$={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},l="en",m={};m[l]=$;var y=function(t){return t instanceof v},M=function(t,n,e){var r;if(!t)return l;if("string"==typeof t)m[t]&&(r=t),n&&(m[t]=n,r=t);else{var i=t.name;m[i]=t,r=i;}return e||(l=r),r},g=function(t,n,e){if(y(t))return t.clone();var r=n?"string"==typeof n?{format:n,pl:e}:n:{};return r.date=t,new v(r)},D=d;D.l=M,D.i=y,D.w=function(t,n){return g(t,{locale:n.$L,utc:n.$u,$offset:n.$offset})};var v=function(){function c(t){this.$L=this.$L||M(t.locale,null,!0),this.parse(t);}var d=c.prototype;return d.parse=function(t){this.$d=function(t){var n=t.date,e=t.utc;if(null===n)return new Date(NaN);if(D.u(n))return new Date;if(n instanceof Date)return new Date(n);if("string"==typeof n&&!/Z$/i.test(n)){var r=n.match(h);if(r)return e?new Date(Date.UTC(r[1],r[2]-1,r[3]||1,r[4]||0,r[5]||0,r[6]||0,r[7]||0)):new Date(r[1],r[2]-1,r[3]||1,r[4]||0,r[5]||0,r[6]||0,r[7]||0)}return new Date(n)}(t),this.init();},d.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},d.$utils=function(){return D},d.isValid=function(){return !("Invalid Date"===this.$d.toString())},d.isSame=function(t,n){var e=g(t);return this.startOf(n)<=e&&e<=this.endOf(n)},d.isAfter=function(t,n){return g(t)<this.startOf(n)},d.isBefore=function(t,n){return this.endOf(n)<g(t)},d.$g=function(t,n,e){return D.u(t)?this[n]:this.set(e,t)},d.year=function(t){return this.$g(t,"$y",a)},d.month=function(t){return this.$g(t,"$M",u)},d.day=function(t){return this.$g(t,"$W",i)},d.date=function(t){return this.$g(t,"$D","date")},d.hour=function(t){return this.$g(t,"$H",r)},d.minute=function(t){return this.$g(t,"$m",e)},d.second=function(t){return this.$g(t,"$s",n)},d.millisecond=function(n){return this.$g(n,"$ms",t)},d.unix=function(){return Math.floor(this.valueOf()/1e3)},d.valueOf=function(){return this.$d.getTime()},d.startOf=function(t,o){var h=this,f=!!D.u(o)||o,c=D.p(t),d=function(t,n){var e=D.w(h.$u?Date.UTC(h.$y,n,t):new Date(h.$y,n,t),h);return f?e:e.endOf(i)},$=function(t,n){return D.w(h.toDate()[t].apply(h.toDate(),(f?[0,0,0,0]:[23,59,59,999]).slice(n)),h)},l=this.$W,m=this.$M,y=this.$D,M="set"+(this.$u?"UTC":"");switch(c){case a:return f?d(1,0):d(31,11);case u:return f?d(1,m):d(0,m+1);case s:var g=this.$locale().weekStart||0,v=(l<g?l+7:l)-g;return d(f?y-v:y+(6-v),m);case i:case"date":return $(M+"Hours",0);case r:return $(M+"Minutes",1);case e:return $(M+"Seconds",2);case n:return $(M+"Milliseconds",3);default:return this.clone()}},d.endOf=function(t){return this.startOf(t,!1)},d.$set=function(s,o){var h,f=D.p(s),c="set"+(this.$u?"UTC":""),d=(h={},h[i]=c+"Date",h.date=c+"Date",h[u]=c+"Month",h[a]=c+"FullYear",h[r]=c+"Hours",h[e]=c+"Minutes",h[n]=c+"Seconds",h[t]=c+"Milliseconds",h)[f],$=f===i?this.$D+(o-this.$W):o;if(f===u||f===a){var l=this.clone().set("date",1);l.$d[d]($),l.init(),this.$d=l.set("date",Math.min(this.$D,l.daysInMonth())).toDate();}else d&&this.$d[d]($);return this.init(),this},d.set=function(t,n){return this.clone().$set(t,n)},d.get=function(t){return this[D.p(t)]()},d.add=function(t,o){var h,f=this;t=Number(t);var c=D.p(o),d=function(n){var e=g(f);return D.w(e.date(e.date()+Math.round(n*t)),f)};if(c===u)return this.set(u,this.$M+t);if(c===a)return this.set(a,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(h={},h[e]=6e4,h[r]=36e5,h[n]=1e3,h)[c]||1,l=this.$d.getTime()+t*$;return D.w(l,this)},d.subtract=function(t,n){return this.add(-1*t,n)},d.format=function(t){var n=this;if(!this.isValid())return "Invalid Date";var e=t||"YYYY-MM-DDTHH:mm:ssZ",r=D.z(this),i=this.$locale(),s=this.$H,u=this.$m,o=this.$M,a=i.weekdays,h=i.months,c=function(t,r,i,s){return t&&(t[r]||t(n,e))||i[r].substr(0,s)},d=function(t){return D.s(s%12||12,t,"0")},$=i.meridiem||function(t,n,e){var r=t<12?"AM":"PM";return e?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:o+1,MM:D.s(o+1,2,"0"),MMM:c(i.monthsShort,o,h,3),MMMM:h[o]||h(this,e),D:this.$D,DD:D.s(this.$D,2,"0"),d:String(this.$W),dd:c(i.weekdaysMin,this.$W,a,2),ddd:c(i.weekdaysShort,this.$W,a,3),dddd:a[this.$W],H:String(s),HH:D.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:D.s(u,2,"0"),s:String(this.$s),ss:D.s(this.$s,2,"0"),SSS:D.s(this.$ms,3,"0"),Z:r};return e.replace(f,function(t,n){return n||l[t]||r.replace(":","")})},d.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},d.diff=function(t,h,f){var c,d=D.p(h),$=g(t),l=6e4*($.utcOffset()-this.utcOffset()),m=this-$,y=D.m(this,$);return y=(c={},c[a]=y/12,c[u]=y,c[o]=y/3,c[s]=(m-l)/6048e5,c[i]=(m-l)/864e5,c[r]=m/36e5,c[e]=m/6e4,c[n]=m/1e3,c)[d]||m,f?y:D.a(y)},d.daysInMonth=function(){return this.endOf(u).$D},d.$locale=function(){return m[this.$L]},d.locale=function(t,n){if(!t)return this.$L;var e=this.clone();return e.$L=M(t,n,!0),e},d.clone=function(){return D.w(this.$d,this)},d.toDate=function(){return new Date(this.valueOf())},d.toJSON=function(){return this.isValid()?this.toISOString():null},d.toISOString=function(){return this.$d.toISOString()},d.toString=function(){return this.$d.toUTCString()},c}();return g.prototype=v.prototype,g.extend=function(t,n){return t(n,v,g),g},g.locale=M,g.isDayjs=y,g.unix=function(t){return g(1e3*t)},g.en=m[l],g.Ls=m,g});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f719":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ module.exports=a(__webpack_require__("5a0c"));}(this,function(e){e=e&&e.hasOwnProperty("default")?e.default:e;var a={name:"en-gb",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekStart:1,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},ordinal:function(e){var a=["th","st","nd","rd"],_=e%100;return "["+e+(a[(_-20)%10]||a[_]||a[0])+"]"}};return e.locale(a,null,!0),a});


/***/ }),

/***/ "f906":
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ module.exports=n();}(this,function(){var t,n=/(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,e=/\d\d/,r=/\d\d?/,o=/\d*[^\s\d-:/.()]+/;var s=function(t){return function(n){this[t]=+n;}},i=[/[+-]\d\d:?\d\d/,function(t){var n,e;(this.zone||(this.zone={})).offset=(n=t.match(/([+-]|\d\d)/g),0===(e=60*n[1]+ +n[2])?0:"+"===n[0]?-e:e);}],a={A:[/[AP]M/,function(t){this.afternoon="PM"===t;}],a:[/[ap]m/,function(t){this.afternoon="pm"===t;}],S:[/\d/,function(t){this.milliseconds=100*+t;}],SS:[e,function(t){this.milliseconds=10*+t;}],SSS:[/\d{3}/,function(t){this.milliseconds=+t;}],s:[r,s("seconds")],ss:[r,s("seconds")],m:[r,s("minutes")],mm:[r,s("minutes")],H:[r,s("hours")],h:[r,s("hours")],HH:[r,s("hours")],hh:[r,s("hours")],D:[r,s("day")],DD:[e,s("day")],Do:[o,function(n){var e=t.ordinal,r=n.match(/\d+/);if(this.day=r[0],e)for(var o=1;o<=31;o+=1)e(o).replace(/\[|\]/g,"")===n&&(this.day=o);}],M:[r,s("month")],MM:[e,s("month")],MMM:[o,function(n){var e=t,r=e.months,o=e.monthsShort,s=o?o.findIndex(function(t){return t===n}):r.findIndex(function(t){return t.substr(0,3)===n});if(s<0)throw new Error;this.month=s+1;}],MMMM:[o,function(n){var e=t.months.indexOf(n);if(e<0)throw new Error;this.month=e+1;}],Y:[/[+-]?\d+/,s("year")],YY:[e,function(t){t=+t,this.year=t+(t>68?1900:2e3);}],YYYY:[/\d{4}/,s("year")],Z:i,ZZ:i};var u=function(t,e,r){try{var o=function(t){for(var e=t.match(n),r=e.length,o=0;o<r;o+=1){var s=e[o],i=a[s],u=i&&i[0],f=i&&i[1];e[o]=f?{regex:u,parser:f}:s.replace(/^\[|\]$/g,"");}return function(t){for(var n={},o=0,s=0;o<r;o+=1){var i=e[o];if("string"==typeof i)s+=i.length;else{var a=i.regex,u=i.parser,f=t.substr(s),h=a.exec(f)[0];u.call(n,h),t=t.replace(h,"");}}return function(t){var n=t.afternoon;if(void 0!==n){var e=t.hours;n?e<12&&(t.hours+=12):12===e&&(t.hours=0),delete t.afternoon;}}(n),n}}(e)(t),s=o.year,i=o.month,u=o.day,f=o.hours,h=o.minutes,d=o.seconds,c=o.milliseconds,m=o.zone;if(m)return new Date(Date.UTC(s,i-1,u,f||0,h||0,d||0,c||0)+60*m.offset*1e3);var l=new Date,v=s||l.getFullYear(),p=i>0?i-1:l.getMonth(),M=u||l.getDate(),y=f||0,D=h||0,Y=d||0,g=c||0;return r?new Date(Date.UTC(v,p,M,y,D,Y,g)):new Date(v,p,M,y,D,Y,g)}catch(t){return new Date("")}};return function(n,e,r){var o=e.prototype,s=o.parse;o.parse=function(n){var e=n.date,o=n.format,i=n.pl,a=n.utc;this.$u=a,o?(t=i?r.Ls[i]:this.$locale(),this.$d=u(e,o,a),this.init(n)):s.call(this,n);};}});


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  {
    __webpack_require__("f6fd");
  }

  var i;
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1]; // eslint-disable-line
  }
}

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"2feb2d1e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/currency-format.vue?vue&type=template&id=8d8c914c&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.customStyle)},[_vm._t("minusSign"),(_vm.position === 0)?[_vm._t("symbol"),_vm._t("amount")]:[_vm._t("amount"),_vm._t("symbol")]],2)};
var staticRenderFns = [];


// CONCATENATED MODULE: ./src/currency-format.vue?vue&type=template&id=8d8c914c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/currency-format.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var currency_formatvue_type_script_lang_js_ = ({
  props: {
    customStyle: {
      type: Object,
      default: function _default() {}
    },
    position: {
      type: Number,
      default: 0
    }
  }
});
// CONCATENATED MODULE: ./src/currency-format.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_currency_formatvue_type_script_lang_js_ = (currency_formatvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports;

  // render functions
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true;
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId;
  }

  var hook;
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot); }
      : injectStyles;
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook;
      // register for functioal component in vue file
      var originalRender = options.render;
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context);
        return originalRender(h, context)
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook];
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/currency-format.vue





/* normalize component */

var component = normalizeComponent(
  src_currency_formatvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
);

/* harmony default export */ var currency_format = (component.exports);
// CONCATENATED MODULE: ./src/currencyFormat.js
/**
 * 一个统一的处理货币的方法，后端改造后方法
 * @prop {function} currencyFormat
 * @param {Object} config:amount：金额; symbol：货币符号；position：符号位置；symbolTemplate：符号模板；amountTemplate：金额模板；literal 货币符号与数字的分隔符；
 * @returns {String} 拼装好的字符串
 */
/* harmony default export */ var currencyFormat = (function (_ref) {
  var _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount,
      symbol = _ref.symbol,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 0 : _ref$position,
      _ref$symbolTemplate = _ref.symbolTemplate,
      symbolTemplate = _ref$symbolTemplate === void 0 ? '' : _ref$symbolTemplate,
      _ref$amountTemplate = _ref.amountTemplate,
      amountTemplate = _ref$amountTemplate === void 0 ? '' : _ref$amountTemplate,
      _ref$literal = _ref.literal,
      literal = _ref$literal === void 0 ? '' : _ref$literal,
      _ref$minusSign = _ref.minusSign,
      minusSign = _ref$minusSign === void 0 ? '' : _ref$minusSign,
      _ref$minusSignTemplat = _ref.minusSignTemplate,
      minusSignTemplate = _ref$minusSignTemplat === void 0 ? '' : _ref$minusSignTemplat;

  if (!symbol) {
    console.error('symbol参数必传!');
    return '';
  }

  var symbolStr = symbol;
  var amountStr = amount;
  var minusSignStr = minusSign;

  if (symbolTemplate) {
    symbolStr = symbolTemplate.replace('%s', symbol);
  }

  if (amountTemplate) {
    amountStr = amountTemplate.replace('%s', amount);
  }

  if (minusSignTemplate) {
    minusSignStr = minusSignTemplate.replace('%s', minusSign);
  }

  return position === 0 ? minusSignStr + symbolStr + literal + amountStr : minusSignStr + amountStr + literal + symbolStr;
});
// CONCATENATED MODULE: ./src/currencyFormatByFront.js
var symbolMap = {
  MXN: 'MX$',
  BRL: 'R$'
};
var supportLocale = ['zh-CN', 'en-US', 'es-MX', 'pt-BR'];
/**
 * 一个统一的处理货币的方法，后端改造前方法，只关注墨西哥和巴西情况，不支持日本货币
 * @prop {function} currencyFormatByFront
 * @param {Object} locale 语言标识;currency 国家标识;amount 金额，单位是滴分; literal 货币符号与数字的分隔符，默认空格；
 * @returns {Object} symbol：货币符号；amount：格式化后的金额
 */

/* harmony default export */ var currencyFormatByFront = (function (_ref) {
  var locale = _ref.locale,
      currency = _ref.currency,
      _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount,
      _ref$literal = _ref.literal,
      literal = _ref$literal === void 0 ? '' : _ref$literal;

  if (!locale || !currency) {
    console.error('locale和currency参数必传!');
    return '';
  }

  if (!symbolMap[currency]) {
    console.error('currency不支持');
    return '';
  }

  if (supportLocale.indexOf(locale) === -1) {
    console.error('locale不支持');
    return '';
  }

  amount = Number(amount);

  if (!Number.isInteger(amount)) {
    console.error('金额应该为滴分单位，并且是整型');
    return '';
  }

  var amountStr = new Intl.NumberFormat(locale, {
    style: 'decimal'
  }).format(amount / 100);
  var minusSign = '';

  if (amount < 0) {
    minusSign = '-';
    amountStr = amountStr.substring(1);
  }

  var position = 0; // 0 在前, 1 在后

  return {
    minusSign: minusSign,
    amount: amountStr,
    symbol: symbolMap[currency],
    position: position,
    display: minusSign + symbolMap[currency] + literal + amountStr
  };
});
// CONCATENATED MODULE: ./src/formatMap.js
/* harmony default export */ var formatMap = ({
  'HH:mm': {
    en: 'hh:mm A',
    es: 'hh:mm A',
    pt: 'hh:mm A',
    ja: 'HH:mm'
  },
  'MM-DD': {
    en: 'MM-DD',
    es: 'DD-MM',
    pt: 'DD-MM',
    ja: 'MM月DD日'
  },
  'MM月DD日': {
    en: 'MM.DD',
    es: 'DD.MM',
    pt: 'DD.MM',
    ja: 'MM月DD日'
  },
  'MM-DD HH:mm': {
    en: 'MM-DD hh:mm A',
    es: 'DD-MM hh:mm A',
    pt: 'DD-MM hh:mm A',
    ja: 'MM-DD HH:mm'
  },
  'YYYY-MM-DD HH:mm': {
    en: 'MM-DD-YYYY hh:mm A',
    es: 'DD-MM-YYYY hh:mm A',
    pt: 'DD-MM-YYYY hh:mm A',
    ja: 'YYYY-MM-DD HH:mm'
  },
  'YYYY年MM月DD日 HH:mm': {
    en: 'MM-DD-YYYY hh:mm A',
    es: 'DD-MM-YYYY hh:mm A',
    pt: 'DD-MM-YYYY hh:mm A',
    ja: 'YYYY/MM/DD HH:mm'
  },
  'YYYY年MM月DD日': {
    en: 'MM.DD.YYYY',
    es: 'DD.MM.YYYY',
    pt: 'DD.MM.YYYY',
    ja: 'YYYY/MM/DD'
  },
  'YYYY.MM.DD HH:mm': {
    en: 'MM.DD.YYYY hh:mm A',
    es: 'DD.MM.YYYY hh:mm A',
    pt: 'DD.MM.YYYY hh:mm A',
    ja: 'YYYY.MM.DD HH:mm'
  },
  'YYYY.MM.DD HH': {
    en: 'MM.DD.YYYY hh A',
    es: 'DD.MM.YYYY hh A',
    pt: 'DD.MM.YYYY hh A',
    ja: 'YYYY.MM.DD HH'
  },
  'YYYY.MM.DD': {
    en: 'MM.DD.YYYY',
    es: 'DD.MM.YYYY',
    pt: 'DD.MM.YYYY',
    ja: 'YYYY.MM.DD'
  },
  'YYYY.MM.DD HH:mm:ss': {
    en: 'MM.DD.YYYY hh:mm:ss A',
    es: 'DD.MM.YYYY hh:mm:ss A',
    pt: 'DD.MM.YYYY hh:mm:ss A',
    ja: 'YYYY.MM.DD HH:mm:ss'
  },
  'YYYY-MM-DD HH:mm:ss': {
    en: 'MM-DD-YYYY hh:mm:ss A',
    es: 'DD-MM-YYYY hh:mm:ss A',
    pt: 'DD-MM-YYYY hh:mm:ss A',
    ja: 'YYYY-MM-DD HH:mm:ss'
  },
  'YYYY-MM-DD': {
    en: 'MM-DD-YYYY',
    es: 'DD-MM-YYYY',
    pt: 'DD-MM-YYYY',
    ja: 'YYYY-MM-DD'
  },
  'MM月DD日 HH时mm分': {
    en: 'MM-DD hh:mm A',
    es: 'DD-MM hh:mm A',
    pt: 'DD-MM hh:mm A',
    ja: 'MM月DD日 HH:mm'
  }
});
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__("5a0c");
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);

// EXTERNAL MODULE: ./node_modules/dayjs/locale/en-gb.js
var en_gb = __webpack_require__("f719");

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__("f906");
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);

// CONCATENATED MODULE: ./src/dayjs.js



dayjs_min_default.a.locale('en-gb');
dayjs_min_default.a.extend(customParseFormat_default.a);
/* harmony default export */ var dayjs = (dayjs_min_default.a);
// CONCATENATED MODULE: ./src/getTimeFormat.js


/* harmony default export */ var getTimeFormat = (function (_ref) {
  var timestamp = _ref.timestamp,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'YYYY-MM-DD' : _ref$format,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'zh-CN' : _ref$locale,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? false : _ref$offset,
      _ref$languageHabit = _ref.languageHabit,
      languageHabit = _ref$languageHabit === void 0 ? true : _ref$languageHabit;

  if (!timestamp) {
    console.error('timestamp参数必传!');
    return '';
  }

  timestamp = Number(timestamp);

  if (!Number.isInteger(timestamp)) {
    console.error('timestamp必须为整数');
    return '';
  }

  if (offset !== false) {
    offset = Number(offset);

    if (!Number.isInteger(offset)) {
      console.error('offset必须为整数');
      return '';
    }
  }

  var language = locale.split('-')[0];
  var targetFormat = '';

  if (language === 'zh') {
    targetFormat = format;
  } else {
    if (languageHabit && formatMap[format] && formatMap[format][language]) {
      targetFormat = formatMap[format][language];
    } else {
      if (languageHabit) {
        console.warn('传入的format不支持按照语言自动进行格式转换');
      }

      targetFormat = format;
    }
  }

  if (offset === false) {
    return dayjs(timestamp).format(targetFormat);
  } else {
    var time = dayjs(timestamp);
    var rs;
    var manipulated = Math.round(offset / 60) - time.utcOffset();

    if (manipulated >= 0) {
      rs = time.add(manipulated, 'minute');
    } else {
      rs = time.subtract(Math.abs(manipulated), 'minute');
    }

    return rs.format(targetFormat);
  }
});
// CONCATENATED MODULE: ./src/locale.js
/*
 * @Author: wangmingxu
 * @Date: 2021-04-16 17:30:42
 * @LastEditTime: 2021-06-22 18:07:27
 * @LastEditors: wangmingxu
 * @Description: locale与language处理场景
 * @FilePath: /i18n-util/src/locale.js
 */
// locale的分隔符
var separator = '-'; // 可支持的语言列表

var LanguageMap = ['zh', 'en', 'es', 'pt', 'ja']; // 可支持的国家列表

var CountryMap = ['MX', 'BR', 'JP', 'CR', 'CO', 'DO', 'CL', 'PE']; // 可支持的locale列表，特殊处理支持es-419 en-US zh-CN语言

var LocaleMap = ['es-419', 'en-US', 'zh-CN']; // 国家对应的默认语言对应关系

var CountryLanguageMap = {
  'MX': 'es-MX',
  'BR': 'pt-BR',
  'JP': 'ja-JP',
  'CR': 'es-419',
  'CO': 'es-419',
  'DO': 'es-419',
  'CL': 'es-419',
  'PE': 'es-419'
};
var CountryNameMap = {
  'CN': 'China',
  'MX': 'Mexico',
  'BR': 'Brazil',
  'JP': 'Japan',
  'CR': 'CostaRica',
  'CO': 'Colombia',
  'DO': 'Dominican',
  'CL': 'Chile',
  'PE': 'Peru'
}; // 国家对应的默认locale对应关系

var CountryLocaleMap = {
  'MX': 'es-MX',
  'BR': 'pt-BR',
  'JP': 'ja-JP',
  'CR': 'es-CR',
  'CO': 'es-CO',
  'DO': 'es-DO',
  'CL': 'es-CL',
  'PE': 'es-PE'
};
/**
 * 可支持的语言包列表，根据语言首先进行划分
 * 如果支持特殊配置，可追加，否则走默认逻辑
 */

var LanguagePackMap = {
  'en': {
    'en-US': 'en-US',
    'default': 'en-US'
  },
  'es': {
    'es-MX': 'es-MX',
    'default': 'es-419'
  },
  'pt': {
    'pt-BR': 'pt-BR',
    'default': 'pt-BR'
  },
  'ja': {
    'ja-JP': 'ja-JP',
    'default': 'ja-JP'
  },
  'zh': {
    'zh-CN': 'zh-CN',
    'default': 'zh-CN'
  }
}; // 根据Lang与Country，匹配得出支持的locale

LanguageMap.forEach(function (lang) {
  CountryMap.forEach(function (country) {
    LocaleMap.push("".concat(lang).concat(separator).concat(country));
  });
});
/**
 * 校验locale是否合理方法
 * @param {*} locale 需要被校验的locale
 * @returns 返回校验通过的locale
 */

var checkLocale = function checkLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var finalLocale = null;
  var lowerCaseLocale = locale.toLowerCase();
  LocaleMap.forEach(function (localeItem) {
    if (localeItem.toLowerCase() === lowerCaseLocale) {
      finalLocale = localeItem;
    }
  });
  return finalLocale;
};
/**
 * @description 获取符合预期的locale
 * @param {string} targetPath 支持传入目标路径与直接从url中获取两种locale处理规则
 * @return {string} locale 符合预期的locale
 */


var getLocale = function getLocale() {
  var targetPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var locale = null;
  var path = targetPath || location.pathname.split('/')[1];
  locale = checkLocale(path);

  if (!locale) {
    locale = checkLocale(window.navigator.language);
  }

  if (!locale) {
    // 兜底逻辑沿用en-US
    locale = "en".concat(separator, "US");
  }

  return locale;
};
/**
 * 获取locale对应的语言包名称与类型
 * @param {*} locale 期望做匹配的locale，会再做一次合理性校验
 * @returns {String} short 语言简写，如element-ui、r-fusion-ui中会使用到
 * @returns {String} long:语言包全称，项目内i18n语言包会使用到
 */


var getLanguage = function getLanguage() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var finalLocale = getLocale(locale);
  var language = finalLocale.split(separator)[0]; // 如果支持对应的语言，又存在对应locale的特殊配置，则直接返回

  if (LanguagePackMap[language] && LanguagePackMap[language][finalLocale]) {
    return {
      short: language,
      long: LanguagePackMap[language][finalLocale]
    }; // 否则返回该语言的默认配置
  } else {
    return {
      short: language,
      long: LanguagePackMap[language]['default']
    };
  }
};
/**
 * 获取locale对应的语言包长名称
 * @param {*} locale 期望做匹配的locale，会再做一次合理性校验
 * @returns {String} 语言包全称，项目内i18n语言包会使用到
 */


var getLanguageLong = function getLanguageLong() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var finalLocale = getLocale(locale);
  var language = finalLocale.split(separator)[0]; // 如果支持对应的语言，又存在对应locale的特殊配置，则直接返回

  if (LanguagePackMap[language] && LanguagePackMap[language][finalLocale]) {
    return LanguagePackMap[language][finalLocale]; // 否则返回该语言的默认配置
  } else {
    return LanguagePackMap[language]['default'];
  }
};
/**
 * 获取locale对应的语言包短名称
 * @param {*} locale 期望做匹配的locale，会再做一次合理性校验
 * @returns {String} 语言简写，如element-ui、r-fusion-ui中会使用到
 */


var getLanguageShort = function getLanguageShort() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var finalLocale = getLocale(locale);
  var language = finalLocale.split(separator)[0];
  return language;
};
/**
 * 获取locale对应的region
 * @param {*} locale 期望做匹配的locale，会再做一次合理性校验
 * @returns {String} region 区域/国家code
 */


var getRegion = function getRegion() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var finalLocale = getLocale(locale);
  var region = finalLocale.split(separator)[1]; // 不再做特殊处理，419区域也会被返回

  return region;
};

var getCountryNameByLocale = function getCountryNameByLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var region = getRegion(locale); // 根据map返回对应全称

  return CountryNameMap[region] || '';
};


// CONCATENATED MODULE: ./src/main.js






var currencyPlugin = {
  install: function install(Vue, options) {
    Vue.component('currency-format', currency_format);
  }
};
/* harmony default export */ var main = ({
  currencyFormat: currencyFormat,
  currencyFormatByFront: currencyFormatByFront,
  getTimeFormat: getTimeFormat,
  getLocale: getLocale,
  getLanguage: getLanguage,
  getLanguageLong: getLanguageLong,
  getLanguageShort: getLanguageShort,
  getRegion: getRegion,
  getCountryNameByLocale: getCountryNameByLocale,
  LanguageMap: LanguageMap,
  CountryMap: CountryMap,
  LocaleMap: LocaleMap,
  LanguagePackMap: LanguagePackMap,
  CountryLanguageMap: CountryLanguageMap,
  CountryLocaleMap: CountryLocaleMap,
  CountryNameMap: CountryNameMap,
  currencyPlugin: currencyPlugin,
  dayjs: dayjs
});
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main);



/***/ })

/******/ });

});

var I18nUtil = unwrapExports(i18nUtil_common);

var sprintf = createCommonjsModule(function (module, exports) {
/* global window, exports, define */

!function() {

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i];
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i]; // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor];
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]];
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no];
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++];
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg();
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0;
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2);
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10);
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break
                    case 's':
                        arg = String(arg);
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg);
                        break
                    case 't':
                        arg = String(!!arg);
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg);
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg);
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0;
                        break
                    case 'v':
                        arg = arg.valueOf();
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg);
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg;
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-';
                        arg = arg.toString().replace(re.sign, '');
                    }
                    else {
                        sign = '';
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' ';
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : '';
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg);
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null);

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0]);
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%');
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1]);
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1]);
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list;
                }
                else {
                    arg_names |= 2;
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                );
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    {
        exports['sprintf'] = sprintf;
        exports['vsprintf'] = vsprintf;
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf;
        window['vsprintf'] = vsprintf;
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line
});

var getLocale = I18nUtil.getLocale,
    getRegion = I18nUtil.getRegion,
    getLanguageLong = I18nUtil.getLanguageLong,
    getLanguageShort = I18nUtil.getLanguageShort;
var languages = {
  'en-US': 'American English',
  'zh-CN': '简体中文',
  'es-MX': 'Español',
  'pt-BR': 'Portuguese',
  'ja-JP': '日本語',
  'es-419': 'Español',
  'es-CO': 'Colombia',
  'es-CR': 'Costa Rica',
  'es-DO': 'Dominican',
  'es-CL': 'Chile',
  'es-PE': 'Peru'
};

var Jed =
/*#__PURE__*/
function () {
  function Jed(data) {
    _classCallCheck(this, Jed);

    this.data = data;
  }

  _createClass(Jed, [{
    key: "_",
    value: function _(key) {
      return this.data[key] || key;
    }
  }, {
    key: "gettext",
    value: function gettext(key) {
      return this.data[key] || key;
    }
  }, {
    key: "ngettext",
    value: function ngettext(singular, plural, count) {
      var key = '';

      if (plural === undefined || count === undefined) {
        key = singular;
      } else if (count > 1) {
        key = plural;
      } else {
        key = singular;
      }

      return this.data[key] || key;
    } // 未使用

  }, {
    key: "pgettext",
    value: function pgettext() {}
  }]);

  return Jed;
}();

Jed.sprintf = sprintf.sprintf;

var VueJed = function VueJed(langData) {
  var _this = this;

  _classCallCheck(this, VueJed);

  var i18n = new Jed(langData);
  this.gettext = i18n.gettext.bind(i18n);
  this._ = this.gettext;
  this.ngettext = i18n.ngettext.bind(i18n);
  this.pgettext = i18n.pgettext.bind(i18n);
  this.plugin = {
    install: function install(Vue, options) {
      Vue.prototype._ = _this.gettext;
      Vue.prototype.gettext = _this.gettext;
      Vue.prototype.ngettext = _this.ngettext;
      Vue.prototype.pgettext = _this.pgettext;
    }
  };
};

var sprintf$1 = Jed.sprintf;

exports.getLocale = getLocale;
exports.getRegion = getRegion;
exports.getLanguageLong = getLanguageLong;
exports.getLanguageShort = getLanguageShort;
exports.VueJed = VueJed;
exports.sprintf = sprintf$1;
exports.languages = languages;
